export default [
  {
    id: 1,
    type: 'featured',
    label: 'featured tours',
    className: 'tab'
  }, {
    id: 2,
    type: 'Sea Tours',
    label: 'sea tours',
    className: 'tab hidden-xs',
  }, {
    id: 3,
    type: 'Land Tours',
    label: 'land tours',
    className: 'tab hidden-xs',
  }, {
    id: 4,
    type: 'all',
    label: 'all tours',
    className: 'tab',
  }
];
